/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Composer, { BaseComposerArgs } from 'cio/components/action-composer/base-glimmer';
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { SlackPreview } from 'cio/utils/previews';
import { getDefaultRecipient } from 'cio/utils/composer/slack';
import { isEmpty } from '@ember/utils';

interface ComposerArgs extends BaseComposerArgs {
  preview: SlackPreview;
}

interface ComposerSignature {
  Args: ComposerArgs;
  Element: HTMLDivElement;
}

export default class Slack extends Composer<ComposerSignature> {
  previewObserverKeys = ['args.editableEntity.template.{recipient,body}'];
  previewURL = 'previews/slack';

  @readOnly('args.editableEntity.template.hasDirtyAttributes') isDirty!: boolean;

  constructor(owner: unknown, args: ComposerSignature['Args']) {
    super(owner, args);
    this.watchTemplate();
  }

  getPreviewData() {
    let to =
      this.args.editableEntity.campaign?.isWebhookTriggered && isEmpty(this.template.recipient)
        ? getDefaultRecipient(this.args.editableEntity.campaign)
        : this.template.recipient;

    return {
      to,
      body: this.template.body,
    };
  }

  @action
  save() {
    if (this.args.editableEntity.campaign?.isWebhookTriggered && isEmpty(this.template.recipient)) {
      this.template.recipient = getDefaultRecipient(this.args.editableEntity.campaign);
    }

    return this.args.onSave();
  }

  @action
  rollback() {
    this.args.editableEntity.template?.rollbackAttributes();

    this.args.onRollback();
  }
}
